import { useProductsTFunction } from '@retail/products/i18n';
import { TableBody, TableRow } from '@mui/material';
import { documentationKeys } from './helpers';
import { StyledKeyTableCell, StyledTableCell } from '../styles';
import { SupplierItemDocumentation } from '@retail/products/types';
import { DownloadDocumentationLink } from './DownloadDocumentationLink';

interface Props {
  supplierItems: SupplierItemDocumentation[];
}

export const DocumentationTableBody = ({ supplierItems }: Props) => {
  const t = useProductsTFunction();

  return (
    <TableBody>
      {documentationKeys.map((key, rowIndex) => (
        <TableRow key={key}>
          <StyledKeyTableCell index={rowIndex}>
            {/* @ts-ignore */}
            {t(`products.mgItem.documentation.${key}`)}
          </StyledKeyTableCell>

          {supplierItems.map((supplierItem, supplierIndex) => {
            return (
              <StyledTableCell
                key={`${rowIndex}-${supplierItem.supplier.id || supplierIndex}`}
                align="center"
                index={rowIndex}
              >
                {supplierItem.documentation?.[key] ? (
                  <DownloadDocumentationLink url={String(supplierItem.documentation?.[key])} />
                ) : (
                  '-'
                )}
              </StyledTableCell>
            );
          })}
        </TableRow>
      ))}
    </TableBody>
  );
};
